/**
 * Identificadores de formulario (scope) del trabajo colaborativo.
 *
 * El scope debe coincidir exactamente con el que calcula el backend
 * (`peritaje/services/collaboration_service.py`): `<typedetail>:<type>`.
 * Se deriva del propio request de guardado, de modo que no hay que declararlo
 * a mano en cada formulario.
 */

// Versión de un formulario que todavía nunca se ha guardado.
export const INITIAL_VERSION = 1;

export const SCOPE_PRINCIPAL = 'principal:';

const MODIFY_RE = /^\/peritaje\/modifyinspection\/([A-Za-z]+)\/\d+/;
const PRINCIPAL_RE = /^\/peritaje\/modifyprincipal\/\d+/;

/** Construye el scope de un formulario a partir de su typedetail y type. */
export function buildScope(typedetail, type) {
  return `${typedetail}:${type || ''}`;
}

/** ¿Esta petición es un guardado de un formulario del peritaje? */
export function isTrackedSave(url, body) {
  return scopeFromRequest(url, body) !== null;
}

/**
 * Devuelve el scope del formulario que guarda esta petición, o null si la
 * petición no es un guardado (lecturas, otros endpoints, etc.).
 */
export function scopeFromRequest(url, body) {
  if (typeof url !== 'string') return null;

  const modify = MODIFY_RE.exec(url);
  if (modify) {
    // Varios formularios escriben sobre la cabecera; el cliente declara su
    // propio scope para no bloquearse entre sí.
    if (body && typeof body === 'object' && body.scope) return String(body.scope);
    const type = body && typeof body === 'object' ? body.type : undefined;
    return buildScope(modify[1], type);
  }

  if (PRINCIPAL_RE.test(url)) return SCOPE_PRINCIPAL;

  return null;
}